module.exports = __webpack_public_path__ + "static/media/oaks2.8a68d48a.jpg";